/** Fila de pedidos dos clientes (portal + registrados por telefone). */
import { createFileRoute } from '@tanstack/react-router';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { z } from 'zod';
import type { Pedido, StatusPedido } from '@sgc/contracts';
import { get } from '../lib/api';
import { useAuth } from '../lib/auth';
import { Sec, Tabs } from '../ui/layout';
import { CartaoPedido, ModalRegistrarPedido } from '../telas/pedidos/comum';

const Busca = z.object({ aba: z.enum(['abertos', 'todos']).optional(), status: z.enum(['ABERTO', 'EM_ANDAMENTO', 'CONCLUIDO', 'RECUSADO', 'CANCELADO']).optional() });
export const Route = createFileRoute('/_app/pedidos')({ validateSearch: Busca, component: Pedidos });

function Pedidos() {
  const qc = useQueryClient();
  const s = Route.useSearch();
  const nav = Route.useNavigate();
  const { eu } = useAuth();
  const papel = eu?.escritorio?.papel;
  const pode = papel === 'ADMIN' || papel === 'SUPERVISOR' || papel === 'OPERADOR';
  const aba = s.aba ?? 'abertos';
  const q = useQuery({ queryKey: ['pedidos', aba, s.status ?? ''], queryFn: () => get<Pedido[]>('/v1/pedidos', aba === 'abertos' ? { abertos: '1' } : s.status ? { status: s.status } : {}), refetchInterval: 60_000 });
  const [novo, setNovo] = useState(false);
  const [busca, setBusca] = useState('');
  const lista = (q.data ?? []).filter((p) => !busca || `${p.clienteNome} ${p.servicoNome} ${p.contatoNome ?? ''} ${p.funcionarioNome ?? ''}`.toLowerCase().includes(busca.toLowerCase()));
  const mudou = (p: Pedido) => qc.setQueryData<Pedido[]>(['pedidos', aba, s.status ?? ''], (old) => (old ?? []).map((x) => (x.id === p.id ? p : x)));
  const porStatus = (st: StatusPedido) => (q.data ?? []).filter((p) => p.status === st).length;
  return (
    <>
      <div className="topbar"><div><h1>Pedidos dos clientes</h1><div className="sub">o que chegou pelo portal ou por telefone; cada pedido tem sua tarefa (ou processo)</div></div>
        <div className="acoes">{pode && <><button className="btn primario" type="button" onClick={() => setNovo(true)}>+ Registrar pedido</button></>}</div></div>
      <div className="conteudo">
      <Tabs valor={aba} onChange={(v) => void nav({ search: { aba: v, status: undefined }, replace: true })} itens={[{ id: 'abertos', rotulo: 'Abertos', contador: aba === 'abertos' ? q.data?.length || undefined : undefined }, { id: 'todos', rotulo: 'Todos' }]} />
      <Sec titulo={aba === 'abertos' ? `Aguardando (${porStatus('ABERTO')}) · em andamento (${porStatus('EM_ANDAMENTO')})` : 'Histórico'}
        acoes={<><input value={busca} onChange={(e) => setBusca(e.target.value)} placeholder="cliente, serviço, quem pediu" style={{ width: 240 }} />{aba === 'todos' && <select value={s.status ?? ''} onChange={(e) => void nav({ search: { aba, status: (e.target.value || undefined) as StatusPedido | undefined }, replace: true })}><option value="">todos os status</option><option value="ABERTO">Aberto</option><option value="EM_ANDAMENTO">Em andamento</option><option value="CONCLUIDO">Concluído</option><option value="RECUSADO">Recusado</option><option value="CANCELADO">Cancelado</option></select>}</>}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {q.isLoading && <div className="dim">carregando…</div>}
          {!q.isLoading && lista.length === 0 && <div className="dim">{aba === 'abertos' ? 'nenhum pedido aberto — quando o cliente pedir pelo portal, aparece aqui e você recebe a notificação' : 'nada por aqui'}</div>}
          {lista.map((p) => <CartaoPedido key={p.id} p={p} mostrarCliente onMudou={mudou} />)}
        </div>
      </Sec>
      {novo && <ModalRegistrarPedido onFechar={() => setNovo(false)} />}
      </div>
    </>
  );
}
